'use client';

import { ImageBrokenIcon } from '@phosphor-icons/react';
import type { ReactNode } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { useTimePilotT } from '@/i18n/useTimePilotT';
import { describeErrorForOps, reportOpsErrorOnce } from '@/lib/ops-log';

export function MediaDisplayErrorFallback(): JSX.Element {
  const t = useTimePilotT();
  return (
    <div
      role="alert"
      data-testid="media-display-error"
      className="flex h-full min-h-[240px] w-full flex-col items-center justify-center gap-2 bg-[var(--surface-inverse,#0f1d32)] px-4 py-6 text-center"
    >
      <ImageBrokenIcon weight="duotone" size={64} className="text-white/80" />
      <p className="text-lg text-white/65">{t('media.previewUnavailable')}</p>
    </div>
  );
}

export function MediaDisplayErrorBoundary({
  resetKey,
  children,
}: {
  resetKey: string;
  children: ReactNode;
}): JSX.Element {
  return (
    <ErrorBoundary
      FallbackComponent={MediaDisplayErrorFallback}
      resetKeys={[resetKey]}
      onError={(error) => {
        const described = describeErrorForOps(error);
        reportOpsErrorOnce(`${resetKey}|${described}`, 'MEDIA_VIEWER_CRASH', described);
      }}
    >
      {children}
    </ErrorBoundary>
  );
}
